import React from 'react'
import type { Icon } from 'shared/utils'

const Map = (props: Icon) => {
    const {
        color = 'white',
        stroke = 'transparent',
        size = 24,
        className = 'map'
    } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path
                d="M11.74 22a.911.911 0 0 1-.675-.3C10.342 20.897 4 13.746 4 9.74 4 5.473 7.472 2 11.74 2c4.269 0 7.741 3.472 7.741 7.74 0 4.006-6.342 11.157-7.065 11.96a.911.911 0 0 1-.675.3zm0-9.66a3.357 3.357 0 0 0 3.353-3.352 3.356 3.356 0 0 0-3.352-3.352 3.356 3.356 0 0 0-3.353 3.352 3.357 3.357 0 0 0 3.353 3.353z"
                fillRule="evenodd"
                stroke={stroke}
            />
        </svg>
    )
}

export { Map }
